
var SMPTEUtils = require('./SMPTE');
var frameRate = 25;

var smpteutils = new SMPTEUtils({frameRate: frameRate});

/**
 * Converts SMPTE time code string to seconds.
 * @param  {String} SMPTE SMPTE format string (format "hh:mm:ss:ff" or "hh:mm:ss")
 * @return {Int}          Timecode in seconds and milliseconds.
 */
var toSeconds = function (SMPTE) {
  var seconds = typeof SMPTE === "number" ? SMPTE : smpteutils.toTimeCode(SMPTE);
  return seconds;
};


/**
 * Creates a promise that plays a video and resolves at the end timecode provided
 * or at the end of the video.
 * @param  {DOMElement|String} Video element or video element ID
 * @param  {Int|String} start        Desired Start Time in Seconds or SMPTE Timecode String (format "hh:mm:ss:ff" or "hh:mm:ss")
 * @param  {Int|String} end          Desired End Time in Seconds or SMPTE Timecode String (format "hh:mm:ss:ff" or "hh:mm:ss")
 * @return {Promise}           Promise resolves at end timecode or end of video.
 */
var videoSequence = function (videoElement, start, end) {
  if (typeof videoElement === "string") {
    videoElement = document.getElementById(videoElement);
  }

  if (videoElement.nodeName !== "VIDEO") {
    throw new Error("Please provide a video element.");
  }

  start = start ? toSeconds(start) : 0;
  end = end ? toSeconds(end) : null;

  var playing = false;

  var controls = {
    play: function () {
      videoElement.play();
      playing = true;
    },
    pause: function () {
      videoElement.pause();
      playing = false;
    },
    stop: function () {
      videoElement.pause();
      playing = false;
      if (typeof callback === "function") {
        callback();
      }
    }
  };

  var startVideo = function () {
    videoElement.currentTime = start;
    videoElement.play();
    playing = true;

    var videoPromise = function (resolve, reject) {

      var handleTimeUpdate = function () {
        if (playing && videoElement.currentTime >= end) {
          playing = false;
          videoElement.pause();
          videoElement.removeEventListener("timeupdate", handleTimeUpdate);
          resolve();
        }
      };

      var handleEnded = function () {
        if (playing) {
          playing = false;
          videoElement.addEventListener("ended", handleEnded);
          resolve();
        }
      };

      if (end) {
        videoElement.addEventListener("timeupdate", handleTimeUpdate);
      } else {
        videoElement.addEventListener("ended", handleEnded);
      }
    };

    return new Promise(videoPromise);
  };

  return {
    controls: controls,
    start: startVideo
  };
};

module.exports = videoSequence;
